<script lang="ts">
  import ErrorBox from './ErrorBox.svelte';
  import { CommonTexts } from '../../services/CommonTexts';

  /** The errors of a request or a check under one headline, nothing without any: every list of errors is shown this way. */
  interface Props {
    errors: string[];
    /** The headline — one of `CommonTexts`. */
    title?: string;
  }

  const { errors, title = CommonTexts.Attention }: Props = $props();
</script>

{#if errors.length > 0}
  <ErrorBox>
    {#snippet headline()}{title}{/snippet}
    {#each errors as error (error)}
      <p>{error}</p>
    {/each}
  </ErrorBox>
{/if}
